import React, { useEffect } from "react";

const GivebutterWidget = ({ widgetId, accountId, page }) => {
  useEffect(() => {
    // Check if the script is already loaded
    if (!document.querySelector(`script[src*="widgets.givebutter.com"]`)) {
      // Create a script element
      const script = document.createElement("script");
      script.src = `https://widgets.givebutter.com/latest.umd.cjs?acct=${accountId}&p=${page}`;
      script.defer = true;
      script.onload = () => {
        console.log("Givebutter widget script loaded successfully.");
      };
      script.onerror = () => {
        console.error("Failed to load the Givebutter widget script.");
      };

      // Append the script to the document head
      document.head.appendChild(script);
    }
  }, [accountId, page]);

  return <givebutter-widget id={widgetId}></givebutter-widget>;
};

export default GivebutterWidget;